// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function cleanObject<T>(item: T): Partial<T> {
  const clonedItem = { ...item };
  Object.keys(clonedItem)
    .filter(key => clonedItem[key] === undefined)
    .forEach(key => delete clonedItem[key]);
  return clonedItem;
}
